import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';

import { join } from 'path';
import urljoin from 'url-join';

import { PageURL } from '@app/core/widgets/pages';

import { PageNotFoundDialog } from '@app/common/components/PageNotFoundDialog/PageNotFoundDialog';
import { PageWithHeader } from '@app/common/components/PageWithHeader/PageWithHeader';
import { withWizardHeartbeat } from '@app/common/configurable-wizards/hocs/withWizardHeartbeat';

import { RetrievalState } from '../user-retrieval/constants';

import { UserKindWizard } from './UserKindWizard';

export const REDIRECT_TO_PARAM = 'redirectTo';

export const getUserKindWizardSearch = (redirectBackUrl: string) => (
  `?${REDIRECT_TO_PARAM}=${redirectBackUrl}`
);
export const getUserKindWizardPath = (redirectBackUrl: string) => (
  urljoin(PageURL.USER_KIND, getUserKindWizardSearch(redirectBackUrl)));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ConfigurableWizard: React.FC = () => {
  const searchParams = useQuery();

  const location = useLocation<RetrievalState>();

  return (
    <PageWithHeader>
      <Switch>
        <Route exact path={`${PageURL.USER_KIND}/:stepId?`}>
          <UserKindWizard
            callbackUrl={searchParams.get(REDIRECT_TO_PARAM)}
            retrievalType={location.state?.retrievalType}
            showForcePasswordResetAlert={location.state?.showForcePasswordResetAlert}
          />
        </Route>
        <Route path={join(PageURL.USER_KIND, '/*/*')} component={PageNotFoundDialog} />
      </Switch>
    </PageWithHeader>
  );
};

export default withWizardHeartbeat(ConfigurableWizard);
